import type { ReactNode } from 'react';

interface Props {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  actions?: ReactNode;
  children: ReactNode;
  footnote?: string;
}

export function ChartCard({ title, subtitle, eyebrow, actions, children, footnote }: Props): JSX.Element {
  return (
    <section className="card avoid-break overflow-hidden">
      <header className="flex flex-wrap items-start justify-between gap-4 border-b border-brand-line px-6 py-5">
        <div>
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h2 className="mt-1 text-xl font-semibold tracking-tight text-brand-ink">{title}</h2>
          {subtitle && <p className="mt-1 max-w-3xl text-sm text-brand-slate">{subtitle}</p>}
        </div>
        {actions && <div className="no-print flex flex-wrap gap-2">{actions}</div>}
      </header>
      <div className="p-6">{children}</div>
      {footnote && (
        <p className="border-t border-brand-line bg-brand-mist px-6 py-3 text-[11px] text-brand-slate">{footnote}</p>
      )}
    </section>
  );
}
